import { createContext } from 'react';

interface AppStateContext {
  visibleBannerType: 'upgrade-account' | 'create-account' | null;
  setUserCreatedNewData: () => void;
}

export const appStateContext = createContext<AppStateContext>(undefined as any);
